import { ReportChartConfiguration } from '@vision/ui/interfaces';
import { FeedbackBasedQuestionBasedMeasureRenderer } from '../../components';
import { TableChart3CompareRenderer } from '../../components/ReportsDetailGraphicChartsRenderer/ReportsDetailGraphicChartsCompareRenderer/TableChart3CompareRenderer';
import { TableChartFcrValueComponent } from '../../components/ReportsDetailGraphicChartsRenderer';
import {
  DefaultReportChartThemeFont,
  DefaultReportChartFormattingRules,
  extendDefaultChartValidationSchema,
} from '../default-chart.config';
import {
  hideCompareForFcr,
  hideFiltersForFcr,
  PieChartFcrCustomizeDefaults,
  TableChartFcrValidationParams,
} from '../pie-chart-fcr.config';
import { TableChart3Measures } from './table-chart3.measures';

export const TableChart3DefaultConfiguration: ReportChartConfiguration = {
  validationSchema: extendDefaultChartValidationSchema({
    params: TableChartFcrValidationParams,
  }),
  measures: TableChart3Measures,
  compareRendererComponent: TableChart3CompareRenderer,
  measureRendererComponent: FeedbackBasedQuestionBasedMeasureRenderer,
  chartValueComponent: TableChartFcrValueComponent,
  compareMultiple: true,
  hideCompareCondition: hideCompareForFcr,
  hideFiltersCondition: hideFiltersForFcr,
  customize: {
    active: (values) => !!values.selectedMeasure && values.selectedCompare.length > 0,
    sortResults: {
      limit: 0,
      order: null,
    },
    limits: {
      upperLimitActive: false,
      upperLimit: 0,
      lowerLimitActive: false,
      lowerLimit: 0,
    },
    transactionalDate: {
      active: false,
    },
    feedbackCount: {
      active: false,
    },
    ...PieChartFcrCustomizeDefaults,
  },
  defaultTheme: {
    active: (values) => !!values.selectedMeasure && values.selectedCompare.length > 0,
    title: {
      ...DefaultReportChartThemeFont,
      label: '',
    },
    dataLabels: {
      ...DefaultReportChartThemeFont,
      fontBold: false,
      active: false,
      displayFormat: 'auto',
      roundingMethod: 'default',
      position: 'center',
    },
    extraSettings: {
      tableHeader: {
        ...DefaultReportChartThemeFont,
        showConduction(values) {
          return !!values.selectedCompare.length;
        },
      },
      tableChart3ColumnView: false,
      tableChart3TransposeRowsAndColumns: false,
    },
    formattingRules: {
      ...DefaultReportChartFormattingRules,
    },
  },
  responseMultiple: false,
};
